export default __webpack_public_path__ + "static/media/menu_3.b3c473a9.png";